import type { FC } from 'react';

export const RedactedPlaceholderComponentShadow: FC = () => null;
